module.exports = __webpack_public_path__ + "img/background_white.9b9163cf.png";